import { InjectionToken } from '@angular/core';

import type { AvatarContext, IconName } from '@core/user-interface-legacy';

export interface NoteAvatarInputValues {
  type: 'initials' | 'image' | 'icon';
  initials?: string;
  imageSrc: string | null;
  iconName: IconName;
  context: AvatarContext;
}

export type NoteAvatarAuthor = {
  photoThumbUrl: string;
  hasAvatar?: boolean;
  initials?: string;
} | null;

export interface NoteAvatarUpdateStrategy {
  getValues: ({
    author,
    triggered,
  }: {
    author: NoteAvatarAuthor;
    triggered: boolean | null;
  }) => NoteAvatarInputValues;
}

export const NOTE_AVATAR_UPDATE_STRATEGY = new InjectionToken<NoteAvatarUpdateStrategy>(
  'NOTE_AVATAR_UPDATE_STRATEGY',
);
